import React from "react";
import {
  Grid,
  TableBody,
  TableRow,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const BankDetails = ({ data }) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={8} xs={12}>
            Bank Transfer Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Receiving Bank Account</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["receiving_bank"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Transaction Mode</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["transaction_payment_mode"]}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Virtual Account Number</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["virtual_account_number"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">UTR Number</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["utr_number"]} </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Customer Ref Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["customer_ref_id"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Partner</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["partner"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Partner Txn Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["partner_txn_id"]}</TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Payer Vpa</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["payer_vpa"]}</TableBodyCell>
                </TableRow>
              </TableBody>

              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Status</TableBodyCell>
                  <TableBodyCell>
                    <BootstrapBadge text={data["status"]} />
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">comment</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Expired At</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["expired_at"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Mobile No.</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["mobile_number"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Credentials Of</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["credentials_of"]}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["created_at"])}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
